<template>
    <div class="kit-header" :style="`background-image: url('${require( '@/assets/'+$root.t('images/kit-banner.png') )}')`">
        <div class="container p-0">
            <div class="row">
                <div class="col-md-12">
                    <div class="kit-header__infos">
                        <small v-html="subtitle"></small>
                        <h2 v-html="title"></h2>
                        <p v-html="description"></p>
                    </div>           
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : [ 'title', 'subtitle', 'description' ]
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/settings/_variables.scss";
@import "@/assets/scss/settings/_mixins.scss";

.kit-header {
    width: 100vw;
    height: 80vh;
    max-height: 500px;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0px;
    color: white;

    * { margin: 0; }

    small {
        text-transform: uppercase;
        color: $c_primary;
        font-size: 16px;
        font-weight: 600;
    }

    h2 { font-size: 48px; text-transform: uppercase; }

    p { max-width: 800px; }
}
</style>